export default "/img/LCO2SensorMap.175e3519b52f1480ce02690550b3159b.svg";